<!--
 * @Description: 更多选项下拉框
 * @Author: Lizhiliang
 * @Date: 2023-12-27 19:03:42
 * @LastEditTime: 2023-12-28 09:48:50
 * @LastEditors: lizhiliang
 * @Usage:
-->

<template>
    <el-dropdown @command="handleCommand">
        <span class="el-dropdown-link">
            {{ text }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
    <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
            v-for="(item, index) in list"
            :key="index"
            :disabled="item.disabled"
            :divided="item.divided"
            :command="item.event"
        >
            {{ item.label }}
        </el-dropdown-item>
    </el-dropdown-menu>
    </el-dropdown>
</template>

<script>
export default {
  name: 'MoreDropdown',
  props: {
    list: {
      type: Array,
      default: []
    },
    text: {
      type: String,
      default: ''
    }
  },
  data() {
    return {

    };
  },

  //   mounted() {

  //   },

  methods: {
    handleCommand(command) {
      console.log('command', command);
      this.$emit('clickItem', command);
    }
  }
};
</script>

<style scoped>
.el-dropdown-link {
  color: #0087ff;
}
</style>
